// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type { GetAwardsError, GetAwardsResponse, GetEntriesData, GetEntriesError, GetEntriesResponse, GetShareLinkData, GetShareLinkError, GetShareLinkResponse, GetShareLinksData, GetShareLinksError, GetShareLinksResponse, GetGameCodesAvailabilityData, GetGameCodesAvailabilityError, GetGameCodesAvailabilityResponse, GetGameCodesData, GetGameCodesError, GetGameCodesResponse, RequestGameCodeData, RequestGameCodeError, RequestGameCodeResponse, GetUserError, GetUserResponse, GetEntryNotesData, GetEntryNotesError, GetEntryNotesResponse, GetEntryNoteData, GetEntryNoteError, GetEntryNoteResponse, SetEntryNoteData, SetEntryNoteError, SetEntryNoteResponse, SetEntryToMyListData, SetEntryToMyListError, SetEntryToMyListResponse, SetEntryWatchedData, SetEntryWatchedError, SetEntryWatchedResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Get all awards
 * Returns all awards visisble to the user.
 */
export const getAwards = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<GetAwardsResponse, GetAwardsError, ThrowOnError>({
    ...options,
    url: '/getAwards'
}); };

/**
 * Get entries for an award OR get My List entries
 * Either returns the entries for an award from `awardId` or returns all My List entries for the user if `onlyMyList` is true.  One of the parameters is required.
 */
export const getEntries = <ThrowOnError extends boolean = false>(options?: Options<GetEntriesData, ThrowOnError>) => { return (options?.client ?? client).get<GetEntriesResponse, GetEntriesError, ThrowOnError>({
    ...options,
    url: '/getEntries'
}); };

/**
 * Get a URL to a media item
 * Returns a new URL that allows temperary access to the specified media item.
 */
export const getShareLink = <ThrowOnError extends boolean = false>(options: Options<GetShareLinkData, ThrowOnError>) => { return (options?.client ?? client).get<GetShareLinkResponse, GetShareLinkError, ThrowOnError>({
    ...options,
    url: '/getShareLink'
}); };

/**
 * Get a URL to a media item
 * Returns a new URL that allows temperary access to the specified media item.
 */
export const getShareLinks = <ThrowOnError extends boolean = false>(options: Options<GetShareLinksData, ThrowOnError>) => { return (options?.client ?? client).get<GetShareLinksResponse, GetShareLinksError, ThrowOnError>({
    ...options,
    url: '/getShareLinks'
}); };

/**
 * Get the games codes/availibility of codes by the member who request the endpoint.
 * Returns games code availability by platform
 */
export const getGameCodesAvailability = <ThrowOnError extends boolean = false>(options: Options<GetGameCodesAvailabilityData, ThrowOnError>) => { return (options?.client ?? client).get<GetGameCodesAvailabilityResponse, GetGameCodesAvailabilityError, ThrowOnError>({
    ...options,
    url: '/getGameCodesAvailability'
}); };

/**
 * Get the games codes/availibility of codes
 * Returns the game code previously retrieved or the availibility of codes for that plaform, for each platform.
 */
export const getGameCodes = <ThrowOnError extends boolean = false>(options: Options<GetGameCodesData, ThrowOnError>) => { return (options?.client ?? client).get<GetGameCodesResponse, GetGameCodesError, ThrowOnError>({
    ...options,
    url: '/getGameCodes'
}); };

/**
 * Get the games codes/availibility of codes
 * Returns the game code previously retrieved or the availibility of codes for that plaform, for each platform.
 */
export const requestGameCode = <ThrowOnError extends boolean = false>(options: Options<RequestGameCodeData, ThrowOnError>) => { return (options?.client ?? client).get<RequestGameCodeResponse, RequestGameCodeError, ThrowOnError>({
    ...options,
    url: '/requestGameCode'
}); };

/**
 * Get logged in user
 * Returns details of the logged in user, including their viewing groups.
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<GetUserResponse, GetUserError, ThrowOnError>({
    ...options,
    url: '/getUser'
}); };

/**
 * Get the created entry notes
 * Get the entry notes created by this user.  Optionally filtered by `awardId` and `categoryId`.
 */
export const getEntryNotes = <ThrowOnError extends boolean = false>(options?: Options<GetEntryNotesData, ThrowOnError>) => { return (options?.client ?? client).get<GetEntryNotesResponse, GetEntryNotesError, ThrowOnError>({
    ...options,
    url: '/getEntryNotes'
}); };

/**
 * Get a created entry note
 * Get the entry note created by this user for the specified entry. `categoryId` is optional but must be passed in to get the category specific note when the award is category specific..
 */
export const getEntryNote = <ThrowOnError extends boolean = false>(options?: Options<GetEntryNoteData, ThrowOnError>) => { return (options?.client ?? client).get<GetEntryNoteResponse, GetEntryNoteError, ThrowOnError>({
    ...options,
    url: '/getEntryNote'
}); };

/**
 * Create or update the entry note
 * Set the entry note for the user for the specified entry. `categoryId` is optional but must be passed in to get the category specific note when the award is category specific..
 */
export const setEntryNote = <ThrowOnError extends boolean = false>(options: Options<SetEntryNoteData, ThrowOnError>) => { return (options?.client ?? client).post<SetEntryNoteResponse, SetEntryNoteError, ThrowOnError>({
    ...options,
    url: '/setEntryNote'
}); };

/**
 * Set whether an entry is in My List or not
 * Set whether the entry is in the user's My List or not. `categoryId` is optional but must be passed in to get the category specific note when the award is category specific..
 */
export const setEntryToMyList = <ThrowOnError extends boolean = false>(options: Options<SetEntryToMyListData, ThrowOnError>) => { return (options?.client ?? client).post<SetEntryToMyListResponse, SetEntryToMyListError, ThrowOnError>({
    ...options,
    url: '/setEntryToMyList'
}); };

/**
 * Set whether an entry is in Watched or or not
 * Set whether the entry is set to Watched or not for the user. `categoryId` is optional but must be passed in to get the category specific note when the award is category specific..
 */
export const setEntryWatched = <ThrowOnError extends boolean = false>(options: Options<SetEntryWatchedData, ThrowOnError>) => { return (options?.client ?? client).post<SetEntryWatchedResponse, SetEntryWatchedError, ThrowOnError>({
    ...options,
    url: '/setEntryWatched'
}); };